export const colors = {
  primaryColor : "#8deb0f",
  secondaryColor : "#0f0f0f",
  textWithWhiteBg : "#181818",
  textWithPrimaryColorBg : "#181818",
  linearGradient :
"linear-gradient(107deg,hsla(0,0%,6%,.6),hsla(0,0%,6%,.36) 33.48%,rgba(141,235,15,.36) 80.05%,rgba(141,235,15,.6) 100.44%)",
darkColor:"#5d9d06"
}